require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ../~/angular/index.js
// module id = 299
// module chunks = 1